
// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// --- Models ---
import { Vehicle, WorkshopSummary } from '@/models/Vehicle.model';

@Component
export default class StatusIndicator extends Vue {
  @Prop() readonly item!: Vehicle | WorkshopSummary;
  @Prop() readonly monochrome: boolean | undefined;
}
